import { Box, FormControl, TextField, InputAdornment } from "@mui/material";
import React from "react";
import { Search, Clear } from "@mui/icons-material";

type Props = {
  search: string;
   // eslint-disable-next-line no-unused-vars
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  clearSearch: Function;
};

const SearchField = (props: Props) => {
  const { search, onSearchChange, clearSearch } = props;
  const handleClick = (): void => {
    clearSearch();
  };
  return (
    <Box className="filters">
      <FormControl>
        <TextField
          size="small"
          variant="outlined"
          placeholder="Search..."
          value={search}
          onChange={onSearchChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment
                position="end"
                style={{
                  display: !search ? "none" : "flex",
                  cursor: "pointer",
                }}
                onClick={handleClick}
              >
                <Clear />
              </InputAdornment>
            ),
          }}
        />
      </FormControl>
    </Box>
  );
};

export default SearchField;
